(() => {
  if (window.__themeCardCartReady) return;
  window.__themeCardCartReady = true;

  const updateCartCount = async () => {
    try {
      const response = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child').forEach((node) => {
        node.textContent = cart.item_count;
      });
      const bubble = document.querySelector('.cart-count-bubble');
      if (bubble) bubble.classList.toggle('hidden', cart.item_count === 0);
    } catch (_) {}
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-theme-card-add]');
    if (!form || form.hasAttribute('data-native-fallback')) return;
    event.preventDefault();

    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const textNode = button.querySelector('span');
    const originalText = textNode?.textContent || '';
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    const formData = new FormData(form);
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    let productAdded = false;
    try {
      const response = await fetch((window.routes && window.routes.cart_add_url) || form.action, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add product');
      productAdded = true;

      try {
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.renderContents(data);
        } else {
          await updateCartCount();
        }
      } catch (uiError) {
        console.warn('[Theme Card Cart] Product added, but cart UI refresh failed:', uiError);
        await updateCartCount();
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      if (textNode) textNode.textContent = 'Added';
      window.setTimeout(() => { if (textNode) textNode.textContent = originalText; }, 1300);
    } catch (error) {
      if (productAdded) {
        console.warn('[Theme Card Cart] Product was added; only the UI update failed:', error);
        await updateCartCount();
        if (textNode) textNode.textContent = 'Added';
      } else {
        console.error('[Theme Card Cart] AJAX add failed, using native Shopify cart form:', error);
        form.setAttribute('data-native-fallback', 'true');
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    }
  });
})();
